var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"dashboard dashboard--tasks"},[_c('tasks-list',{ref:"tasksList",on:{"loaded":_vm.handleLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }